import { render, staticRenderFns } from "./CommonFooter.vue?vue&type=template&id=59a8df75&scoped=true"
import script from "./CommonFooter.vue?vue&type=script&lang=js"
export * from "./CommonFooter.vue?vue&type=script&lang=js"
import style0 from "./CommonFooter.vue?vue&type=style&index=0&id=59a8df75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a8df75",
  null
  
)

export default component.exports